import { Common } from "./types";

export const initialCommonState: Common = {
  noticeMessage: "",
  pathname: "",
};
